import React, { useState } from 'react'
import PropagateLoader from "react-spinners/PropagateLoader";
import { useSelector } from 'react-redux';
import DataTables from '../LMS_DATA_TABLE/DataTable';

export default function TrackDetails(props) {

    const { detailModal, setDetailModal, modalLoading, setModalLoading } = props;

    const data = useSelector(state => state.trackDetails && state.trackDetails.data && state.trackDetails.data.data && state.trackDetails.data.data[0] && state.trackDetails.data.data[0].lms_learning_courses)
    const details = useSelector(state => state.trackDetails && state.trackDetails.data && state.trackDetails.data.data && state.trackDetails.data.data[0])
    // console.log(data)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'IMAGE',
            field: 'thumbnail_image',
            cellRenderer: (params) => <img src={process.env.REACT_APP_IMAGE_URL + `${params.value}`} alt="img" className='img-fluid' width="50" height="50" />,
            suppressMenu: true,
            filter: false,
            sortable: false,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'course_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'DEPARTMENT',
        //     field: 'department_data',
        //     valueFormatter: function (params) {
        //         return params.data.department_data.map(val => `${val.label}`).join(',')
        //     },
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'REVISION',
            field: 'revise',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ORDER',
            field: 'order',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt_course',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     field: 'ACTIONS',
        //     cellRenderer: params =>
        //         <div>
        //             <FaEye size={20} className='eye'
        //                 onClick={() => course_details(params)}
        //                 data-tooltip-id='details'
        //                 data-tooltip-content="Course Details!"
        //                 data-tooltip-place="bottom"
        //             />
        //             <FiRefreshCw size={20} className='edit ms-3'
        //                 onClick={() => edit_course(params)}
        //                 data-tooltip-id='revise'
        //                 data-tooltip-content="Revise Course!"
        //                 data-tooltip-place="bottom"
        //             />
        //             <BiArchiveIn size={20} className='archive ms-3'
        //                 onClick={() => archive_course(params)}
        //                 data-tooltip-id='archive'
        //                 data-tooltip-content="Archive!"
        //                 data-tooltip-place="bottom"
        //             />

        //             <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
        //             <Tooltip id='revise' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
        //             <Tooltip id='archive' style={{ backgroundColor: "rgb(255,193,7)", zIndex: '9', lineHeight: 'normal' }} />
        //         </div>,
        //     // cellRenderer: UserListAction,
        //     // cellRendererParams: {
        //     //     editModal: setEditVenue,
        //     //     modalLoading: setModalLoading,
        //     //     editForm: setEdit,
        //     // },
        //     // wrapText: true,
        //     autoHeight: true,
        // }
    ]);

    return (
        <>
            <div className={detailModal ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }}>
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Learning Track Details</h5>
                            {/* <span className={details && details.status == 'active' ? 'badge text-bg-success ms-2' : 'badge text-bg-danger ms-2'}
                                style={{ textTransform: 'capitalize' }}>{modalLoading ? 'Loading...' : details && details.status}</span> */}
                            <button type="button" className="btn-close" style={{ boxShadow: 'none' }} onClick={() => { setDetailModal(false); setModalLoading(true) }}></button>
                        </div>

                        {modalLoading ?
                            <div className="modal-body">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className="modal-body">
                                <div className='d-flex align-items-baseline'>
                                    <span style={{ color: '#9d9d9d' }}>Learning Track Name:</span>
                                    <h6 className='ms-2'>{details && details.learning_title}</h6>
                                </div>
                                <div className='d-flex align-items-baseline mb-2'>
                                    <span style={{ color: '#9d9d9d' }}>Created on:</span>
                                    <h6 className='ms-2'>{details && details.createdAt}</h6>
                                </div>

                                <DataTables
                                    rowData={data}
                                    columnDefs={columnDefs}
                                    height='45vh'
                                />

                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
